<ng-container *ngIf="isBrowser() && partner?.partnerid?.length > 0">
    <ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>
</ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homemodeMobile>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'hotelonly'" [ngTemplateOutlet]="homemodeMobilehotel"></ng-container>
        <ng-container *ngSwitchCase="'railtravel'" [ngTemplateOutlet]="homemodeMobilerailtravel"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homemodeMobilepauschal"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homemodeMobilehotel>
    <div class="tmp-extra-wrapper-mobile">
        <clever-selectedfilters [mode]="'home'" [type]="type" [isDisabled]="false"></clever-selectedfilters>
        <div class="tmp-section-wrapper-mobile">
            <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }
            @if(!partner.filters?.hideVerpflegungabfilter) {
            <clever-verpflegung [media]="media" [mode]="'home'" [partner]="partner"></clever-verpflegung> }
        </div>
        <div class="tmp-section-wrapper-mobile">
            <clever-room-type-list [mode]="'home'" [partner]="partner"></clever-room-type-list>
            @if(!partner.filters?.hideMeerfilter) {
            <clever-meer [mode]="'home'" [partner]="partner"></clever-meer>
            }

        </div>
        <div class="tmp-section-wrapper-mobile">

            <clever-facility-list [mode]="'home'" [partner]="partner"></clever-facility-list>

        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1 blue" (click)="resetAll()" matRipple>
            <span multilang>Alle Filter löschen</span>
        </button>
    </div>
    <div class="fixed">
        <button class="closebtn" (click)="closeextras()" matRipple>
            <span multilang>ÜBERNEHMEN</span>
        </button>
    </div>
</ng-template>

<ng-template #homemodeMobilerailtravel>
    <div class="tmp-extra-wrapper-mobile">
        <clever-selectedfilters [mode]="'home'" [type]="type" [isDisabled]="false"></clever-selectedfilters>
        <div class="tmp-section-wrapper-mobile">
            <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }
            @if(!partner.filters?.hideVerpflegungabfilter) {
            <clever-verpflegung [media]="media" [mode]="'home'" [partner]="partner"></clever-verpflegung> }
        </div>
        <div class="tmp-section-wrapper-mobile">
            <clever-room-type-list [mode]="'home'" [partner]="partner"></clever-room-type-list>
            @if(!partner.filters?.hideMeerfilter) {
            <clever-meer [mode]="'home'" [partner]="partner"></clever-meer>
            }

        </div>
        <div class="tmp-section-wrapper-mobile">
            <clever-facility-list [mode]="'home'" [partner]="partner"></clever-facility-list>
        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1 blue" (click)="resetAll()" matRipple>
            <span multilang>Alle Filter löschen</span>
        </button>
    </div>
    <div class="fixed">
        <button class="closebtn" (click)="closeextras()" matRipple>
            <span multilang>ÜBERNEHMEN</span>
        </button>
    </div>
</ng-template>

<ng-template #homemodeMobilepauschal>
    <div class="tmp-extra-wrapper-mobile">
        <clever-selectedfilters [mode]="'home'" [type]="type" [isDisabled]="false"></clever-selectedfilters>
        <div class="tmp-section-wrapper-mobile">
            <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }
            @if(!partner.filters?.hideVerpflegungabfilter) {
            <clever-verpflegung [media]="media" [mode]="'home'" [partner]="partner"></clever-verpflegung> }
        </div>
        <div class="tmp-section-wrapper-mobile">
            <clever-room-type-list [mode]="'home'" [partner]="partner"></clever-room-type-list>
            @if(!partner.filters?.hideMeerfilter) {
            <clever-meer [mode]="'home'" [partner]="partner"></clever-meer>
            }

        </div>
        <div class="tmp-section-wrapper-mobile">
            @if(!partner.filters?.hideZwischenstoppsfilter) {
            <clever-direktflug [mode]="'home'" [partner]="partner"></clever-direktflug>
            }
            <clever-facility-list [mode]="'home'" [partner]="partner"></clever-facility-list>
            @if(!partner.filters?.hideFluggesellschaftenfilter) {
            <clever-flight-carrier-list [mode]="'nohome'" [flightCarrierList]="tmp_stat?.flightCarrierList">
            </clever-flight-carrier-list> }
        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1 blue" (click)="resetAll()" matRipple>
            <span multilang>Alle Filter löschen</span>
        </button>
    </div>
    <div class="fixed">
        <button class="closebtn" (click)="closeextras()" matRipple>
            <span multilang>ÜBERNEHMEN</span>
        </button>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'hotelonly'" [ngTemplateOutlet]="homefilterdeskhotel"></ng-container>
        <ng-container *ngSwitchCase="'railtravel'" [ngTemplateOutlet]="homefilterdeskrailtravel"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdeskpauschal"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdeskhotel>
    <div class="tmp-extra-wrapper">
        <div style="max-width:20rem;">
            <clever-selectedfilters [mode]="'home'" [type]="type" [isDisabled]="false"></clever-selectedfilters>
        </div>
        <div class="tmp-section-wrapper">
            <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }

            @if(!partner.filters?.hideHotelkategorieabfilter) {
            <clever-category [mode]="'home'"></clever-category>
            }

        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideWeiterempfehlungfilter) {
            <clever-percent [mode]="'home'"></clever-percent>
            }
            @if(!partner.filters?.hideMeerfilter) {
            <clever-meer [mode]="'home'" [partner]="partner"></clever-meer>
            }
            @if(!partner.filters?.hideVerpflegungabfilter) {
            <clever-verpflegung [media]="media" [mode]="'home'" [partner]="partner"></clever-verpflegung> }

        </div>
    </div>
    <div class="tmp-footer">
        <span multilang></span>
        <div class="tmp-flexy">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span multilang>Alle Filter löschen</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span multilang>{{'Schließen' }}</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #homefilterdeskrailtravel>
    <div class="tmp-extra-wrapper">
        <div style="max-width:20rem;">
            <clever-selectedfilters [mode]="'home'" [type]="type" [isDisabled]="false"></clever-selectedfilters>
        </div>
        <div class="tmp-section-wrapper">
            <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }

            @if(!partner.filters?.hideHotelkategorieabfilter) {
            <clever-category [mode]="'home'"></clever-category>
            }

        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideWeiterempfehlungfilter) {
            <clever-percent [mode]="'home'"></clever-percent>
            }
            @if(!partner.filters?.hideMeerfilter) {
            <clever-meer [mode]="'home'" [partner]="partner"></clever-meer>
            }
            @if(!partner.filters?.hideVerpflegungabfilter) {
            <clever-verpflegung [media]="media" [mode]="'home'" [partner]="partner"></clever-verpflegung> }

        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideZwischenstoppsfilter) {
            <clever-direktflug [mode]="'home'" [partner]="partner"></clever-direktflug>
            }
            @if(!partner.filters?.hideTransferfilter) {
            <clever-transfer [mode]="'home'" [partner]="partner"></clever-transfer>
            }
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideZielflughafenfilter) {
            <clever-airport [mode]="'home'"></clever-airport>
            }
            @if(!partner.filters?.hideHinflugzeitfilter) {
            <clever-flightzeit [mode]="'home'" [title]="'Hinflugzeit'" [isHinflug]="true"></clever-flightzeit>
            }
            @if(!partner.filters?.hideRuckflugzeitfilter) {
            <clever-flightzeit [mode]="'home'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit>
            }
        </div>
    </div>
    <div class="tmp-footer">
        <span multilang></span>
        <div class="tmp-flexy" style="padding:0 1.5rem;">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span multilang>{{'Alle Filter löschen' }}</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span multilang>{{'Schließen' }}</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #homefilterdeskpauschal>
    <div class="tmp-extra-wrapper">
        <div style="max-width:20rem;">
            <clever-selectedfilters [mode]="'home'" [type]="type" [isDisabled]="false"></clever-selectedfilters>
        </div>
        <div class="tmp-section-wrapper">
            <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
            @if(!partner.filters?.hidePreisproPersonfilter) {
            <clever-price [mode]="'home'"></clever-price>
            }

            @if(!partner.filters?.hideHotelkategorieabfilter) {
            <clever-category [mode]="'home'"></clever-category>
            }
            <div class="tmp-flexy" style="margin-top:1.5rem;padding:0 0.5rem">
                <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                    <span multilang>{{'Alle Filter löschen'}}</span>
                </button>
            </div>
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideWeiterempfehlungfilter) {
            <clever-percent [mode]="'home'"></clever-percent>
            }
            @if(!partner.filters?.hideMeerfilter) {
            <clever-meer [mode]="'home'" [partner]="partner"></clever-meer>
            }
            @if(!partner.filters?.hideVerpflegungabfilter) {
            <clever-verpflegung [media]="media" [mode]="'home'" [partner]="partner"></clever-verpflegung> }

            @if(!partner?.filters?.hideflexiblefilter) {
            <clever-flexibel [tourOperatorList]="tourOperatorList" [context]="'home'"
                [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-flexibel>
            }

        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideZwischenstoppsfilter) {
            <clever-direktflug [mode]="'home'" [partner]="partner"></clever-direktflug>
            }
            @if(!partner.filters?.hideTransferfilter) {
            <clever-transfer [mode]="'home'" [partner]="partner"></clever-transfer>
            }
        </div>
        <mat-divider vertical class="custom-divider-vertical"></mat-divider>
        <div class="tmp-section-wrapper">
            @if(!partner.filters?.hideZielflughafenfilter) {
            <clever-airport [mode]="'home'"></clever-airport>
            }
            @if(!partner.filters?.hideHinflugzeitfilter) {
            <clever-flightzeit [mode]="'home'" [title]="'Hinflugzeit'" [isHinflug]="true"></clever-flightzeit>
            }
            @if(!partner.filters?.hideRuckflugzeitfilter) {
            <clever-flightzeit [mode]="'home'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit>
            }
        </div>
    </div>
    <!-- <div class="tmp-footer">
        <div class="tmp-flexy" style="padding:0 1.5rem;">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span multilang >{{'Alle Filter löschen' }}</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span multilang >{{'Schließen' }}</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div> -->
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="nohome-wrapper-desk">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #nohomemodeMobile>
    <div class="nohome-wrapper">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>


<ng-template #myfilters>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'hotelonly'" [ngTemplateOutlet]="myfiltershotel"></ng-container>
        <ng-container *ngSwitchCase="'railtravel'" [ngTemplateOutlet]="myfiltersrailtravel"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="myfilterspauschal"></ng-container>
    </ng-container>
</ng-template>

<ng-template #myfiltershotel>
    <ng-container *ngIf="mode === 'offers'">
        <clever-preisalarme></clever-preisalarme>
    </ng-container>
    <ng-container *ngIf="!loading(); else skloading">
        @if(!partner?.filters?.hideflexiblefilter) {
        <clever-flexibel [tourOperatorList]="tourOperatorList" [context]="mode"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-flexibel>
        }
        @if(!partner?.filters?.hidePreisproPersonfilter) {
        <clever-price [mode]="'nohome'"></clever-price>
        }
        <ng-container *ngIf="mode !== 'offers'">
            @if(!partner?.filters?.hideHotelkategorieabfilter) {
            <clever-category [mode]="'nohome'"></clever-category>
            }
            @if(!partner?.filters?.hideWeiterempfehlungfilter) {
            <clever-percent [mode]="'nohome'"></clever-percent>
            }
            @if(!partner?.filters?.hideAnzahlBewertungenfilter) {
            <clever-recomcount></clever-recomcount>
            }
        </ng-container>
        <ng-container *ngIf="mode !== 'offers'">
            <clever-keywords [mode]="'nohome'" [partner]="partner" [onlyLage]="true"></clever-keywords>
        </ng-container>
        @if(!partner.filters?.hideVerpflegungabfilter) {
        <clever-verpflegung [media]="media" [mode]="'nohome'" [partner]="partner"
            [boardTypeList]="tmp_stat?.boardTypeList"></clever-verpflegung>
        }
        @if((mode !== 'offers' || realparams?.provider === 'peakwork') && !partner.filters?.hideZimmertypfilter) {
        <clever-room-type-list [mode]="'nohome'" [partner]="partner"
            [roomTypeListExt]="tmp_stat?.roomTypeList"></clever-room-type-list>
        }
        <ng-container *ngIf="tmp_stat?.roomIdList?.length > 0 && mode === 'offers'">
            <clever-roomid [mode]="'nohome'" [roomIdList]="tmp_stat?.roomIdList"></clever-roomid>
        </ng-container>
        @if(!partner.filters?.hideMeerfilter) {
        <clever-meer [mode]="'nohome'" [partner]="partner"></clever-meer>
        }
        @if(!partner.filters?.hideinklusivefilter) {
        <clever-inclusive-list [mode]="'nohome'" [partner]="partner"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-inclusive-list>
        }
        @if(!partner.filters?.hideAusstattungfilter) {
        <clever-facility-list [mode]="'nohome'" [partner]="partner"></clever-facility-list>
        }
        @if(!partner.filters?.hideVeranstalterfilter) {
        <clever-touroperator [mode]="'nohome'" [partner]="partner"
            [tourOperatorList]="tmp_stat?.tourOperatorList"></clever-touroperator>
        }
        <ng-container *ngIf="mode !== 'offers'">
            @if(!partner.filters?.hideHotelkettefilter) {
            <clever-hotel-chain-list [mode]="'nohome'" [hotelChainList]="tmp_stat?.hotelChainList">
            </clever-hotel-chain-list>
            }
        </ng-container>
    </ng-container>
    <ng-container *ngIf="mode !== 'offers'">
        <clever-keywords [mode]="'nohome'" [partner]="partner"></clever-keywords>
    </ng-container>
</ng-template>

<ng-template #myfiltersrailtravel>
    <ng-container *ngIf="mode === 'offers'">
        <clever-preisalarme></clever-preisalarme>
    </ng-container>
    <ng-container *ngIf="!loading(); else skloading">
        @if(!partner?.filters?.hideflexiblefilter) {
        <clever-flexibel [tourOperatorList]="tourOperatorList" [context]="mode"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-flexibel>
        }
        @if(!partner?.filters?.hidePreisproPersonfilter) {
        <clever-price [mode]="'nohome'"></clever-price>
        }
        @if(mode !== 'offers') {
        @if(!partner.filters?.hideHotelkategorieabfilter) {
        <clever-category [mode]="'nohome'"></clever-category>
        }
        @if(!partner.filters?.hideWeiterempfehlungfilter) {
        <clever-percent [mode]="'nohome'"></clever-percent>
        }
        @if(!partner.filters?.hideAnzahlBewertungenfilter) {
        <clever-recomcount></clever-recomcount>
        }
        }
        @if(mode !== 'offers') {
        <clever-keywords [mode]="'nohome'" [partner]="partner" [onlyLage]="true"></clever-keywords>
        }
        @if(!partner.filters?.hideVerpflegungabfilter) {
        <clever-verpflegung [media]="media" [mode]="'nohome'" [partner]="partner"
            [boardTypeList]="tmp_stat?.boardTypeList"></clever-verpflegung>
        }
        @if((mode !== 'offers' || realparams?.provider === 'peakwork') && !partner.filters?.hideZimmertypfilter) {
        <clever-room-type-list [mode]="'nohome'" [partner]="partner"
            [roomTypeListExt]="tmp_stat?.roomTypeList"></clever-room-type-list>
        }
        <ng-container *ngIf="tmp_stat?.roomIdList?.length > 0 && mode === 'offers'">
            <clever-roomid [mode]="'nohome'" [roomIdList]="tmp_stat?.roomIdList"></clever-roomid>
        </ng-container>

        @if(!partner.filters?.hideMeerfilter) {
        <clever-meer [mode]="'nohome'" [partner]="partner"></clever-meer>
        }
        <clever-klasse [mode]="'nohome'"></clever-klasse>

        @if(!partner.filters?.hideinklusivefilter) {
        <clever-inclusive-list [mode]="'nohome'" [partner]="partner"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-inclusive-list>
        }
        @if(!partner.filters?.hideAusstattungfilter) {
        <clever-facility-list [mode]="'nohome'" [partner]="partner"></clever-facility-list>
        }
        @if(!partner.filters?.hideVeranstalterfilter) {
        <clever-touroperator [mode]="'nohome'" [partner]="partner"
            [tourOperatorList]="tmp_stat?.tourOperatorList"></clever-touroperator>
        }
        @if(mode !== 'offers' && !partner.filters?.hideHotelkettefilter) {
        <clever-hotel-chain-list [mode]="'nohome'" [hotelChainList]="tmp_stat?.hotelChainList">
        </clever-hotel-chain-list>
        }
    </ng-container>
    @if(!partner.filters?.hideHinflugzeitfilter) {
    <clever-flightzeit [mode]="'nohome'" [title]="'Hinfahrtzeit'" [isHinflug]="true"></clever-flightzeit>
    }
    @if(!partner.filters?.hideRuckflugzeitfilter) {
    <clever-flightzeit [mode]="'nohome'" [title]="'Rückfahrtzeit'" [isHinflug]="false"></clever-flightzeit>
    }
    @if(mode !== 'offers') {
    <clever-keywords [partner]="partner" [mode]="'nohome'"></clever-keywords>
    }
</ng-template>

<ng-template #myfilterspauschal>
    <!-- @if(mode === 'offers') {
    <clever-preisalarme></clever-preisalarme>
    } -->
    <ng-container *ngIf="!loading(); else skloading">
        <clever-beliebtefilter [scroll]=false></clever-beliebtefilter>
        @if(!partner?.filters?.hideflexiblefilter) {
        <clever-flexibel [tourOperatorList]="tourOperatorList" [context]="mode"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-flexibel>
        }
        @if(!partner?.filters?.hidePreisproPersonfilter) {
        <clever-price [mode]="'nohome'"></clever-price>
        }
        @if(mode !== 'offers') {
        @if(!partner.filters?.hideHotelkategorieabfilter) {
        <clever-category [mode]="'nohome'"></clever-category>
        }
        @if(!partner.filters?.hideWeiterempfehlungfilter) {
        <clever-percent [mode]="'nohome'"></clever-percent>
        }
        @if(!partner.filters?.hideAnzahlBewertungenfilter) {
        <clever-recomcount></clever-recomcount>
        }
        <clever-keywords [mode]="'nohome'" [partner]="partner" [onlyLage]="true"></clever-keywords>
        }
        @if(!partner.filters?.hideVerpflegungabfilter) {
        <clever-verpflegung [media]="media" [mode]="'nohome'" [partner]="partner"
            [boardTypeList]="tmp_stat?.boardTypeList"></clever-verpflegung>
        }
        <clever-room-type-list [mode]="'nohome'" [partner]="partner"
            [roomTypeListExt]="tmp_stat?.roomTypeList"></clever-room-type-list>
        <!-- @if(tmp_stat?.roomIdList?.length > 0 && mode === 'offers') {
        <clever-roomid [mode]="'nohome'" [roomIdList]="tmp_stat?.roomIdList"></clever-roomid>
        } -->
        @if(!partner.filters?.hideMeerfilter) {
        <clever-meer [mode]="'nohome'" [partner]="partner"></clever-meer>
        }
        @if(!partner.filters?.hideZwischenstoppsfilter) {
        <clever-direktflug [mode]="'nohome'" [partner]="partner"></clever-direktflug>
        }
        <!-- @if(!partner.filters?.hideTransferfilter) {
        <clever-transfer [mode]="'nohome'" [partner]="partner"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-transfer>
        }
        @if(!partner.filters?.hideinklusivefilter) {
        <clever-inclusive-list [mode]="'nohome'" [partner]="partner"
            [inclusiveListExt]="tmp_stat?.inclusiveCodeList"></clever-inclusive-list>
        } -->
        @if(!partner.filters?.hideAusstattungfilter) {
        <clever-facility-list [mode]="'nohome'" [partner]="partner"></clever-facility-list>
        }
        @if(!partner.filters?.hideFluggesellschaftenfilter) {
        <clever-flight-carrier-list [mode]="'nohome'" [flightCarrierList]="tmp_stat?.flightCarrierList">
        </clever-flight-carrier-list> }
        @if(!partner.filters?.hideVeranstalterfilter) {
        <clever-touroperator [mode]="'nohome'" [partner]="partner"
            [tourOperatorList]="tmp_stat?.tourOperatorList"></clever-touroperator>
        }
        <!-- @if(mode !== 'offers' && !partner.filters?.hideHotelkettefilter) {
        <clever-hotel-chain-list [mode]="'nohome'" [hotelChainList]="tmp_stat?.hotelChainList">
        </clever-hotel-chain-list>
        } -->

        @if(!partner.filters?.hideAbflughafenfilter) {
        <clever-airport [mode]="'nohome'" [isArrival]="false" [title]="'Abflughafen'"
            [airports]="tmp_stat?.departureAirportList"></clever-airport>
        }
        @if(!partner.filters?.hideZielflughafenfilter) {
        <clever-airport [mode]="'nohome'" [title]="'Zielflughafen'"
            [airports]="tmp_stat?.arrivalAirportList"></clever-airport>
        }
    </ng-container>
    @if(!partner.filters?.hideHinflugzeitfilter) {
    <clever-flightzeit [mode]="'nohome'" [title]="'Hinflugzeit'" [isHinflug]="true"></clever-flightzeit>
    }
    @if(!partner.filters?.hideRuckflugzeitfilter) {
    <clever-flightzeit [mode]="'nohome'" [title]="'Rückflugzeit'" [isHinflug]="false"></clever-flightzeit>
    }
    <!-- <ng-container *ngIf="mode !== 'offers'">
        <clever-keywords [mode]="'nohome'" [partner]="partner"></clever-keywords>
    </ng-container> -->
</ng-template>

<ng-template #skloading>
    <div style="width: 100%;display: flex;flex-direction: column;margin-bottom: 1rem;">
        <div class="skeleton" style="height: 20px;width: 200px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 150px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 100px;margin-top: .5rem;"></div>
    </div>
</ng-template>